export default {
    namespaced: true,
    state: {
        is_close_menu : false
    },
    mutations: {
        setStatusOpenCloseMenu : (state, payload) => {
          state.is_close_menu = payload;
        }
    },
    actions: {
        setStatusCloseMenu : (state, payload) => {
          state.commit("setStatusOpenCloseMenu", payload);
        }
    },
    getters: {
        statusCloseMenu: (state) => state.is_close_menu,
    },
}